<template>
    <div class="obras_comerciales_secciones">
        <h2 class="text-center">{{seccion.titulo}}</h2>
        <div v-html="seccion.descripcion">

        </div>
        <div class="caja-secciones-imagenes mb-4">
            <div class="grid__item tablet-and-up-one-half">
                <router-link to="/obras_comerciales/interiorismo" tag="a">
                    <div class="block" :style="{ backgroundImage: 'url(' + require('@/assets/img/obras_comerciales_secciones/interiorismo_comercial.jpg') + ')' }">
                        <div class="label">
                            <div class="title beta label-h3">INTERIORISMO COMERCIAL</div>
                        </div>
                        <div class="overlay-boxes o-7"></div>
                    </div>
                </router-link>
			</div>
             <div class="grid__item tablet-and-up-one-half">
                <router-link to="/obras_comerciales/escaparatismo" tag="a">
                    <div class="block" :style="{ backgroundImage: 'url(' + require('@/assets/img/obras_comerciales_secciones/escaparatismo.jpg') + ')' }">
                        <div class="label">
                            <div class="title beta label-h3">ESCAPARATISMO</div>
                        </div>
                        <div class="overlay-boxes o-4"></div>
                    </div>
                </router-link>
			</div>
              <div class="grid__item tablet-and-up-one-half">
                <router-link to="/obras_comerciales/visual" tag="a">
                    <div class="block" :style="{ backgroundImage: 'url(' + require('@/assets/img/obras_comerciales_secciones/visual.jpg') + ')' }">
                        <div class="label">
                            <div class="title beta label-h3">VISUAL MERCHANDISING</div>
                        </div>
                        <div class="overlay-boxes o-7"></div>
                    </div>
                </router-link>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            seccion:{}
        }
    },
    methods:{
         loadSeccion () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/descripciones/rows?filters[seccion][eq]=comercial`)
        .then(function (data) {
            this.seccion = data.body.data[0];
        })
      }
    },
    mounted() {
    this.$nextTick(() => {
      this.loadSeccion();
 
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/obras/Obras_comerciales_secciones.vue